// Shared list of conference partners / sponsors.
// Add or edit sponsors here — they appear on the Home page strip
// and the Resources page Sponsors section.
export const SPONSORS = [
  {
    name: "CDW",
    logo: "/images/cdw.png",
  },
  {
    name: "ClearWinds",
    logo: "/images/clearwinds.png",
  },
  {
    name: "District Management Group",
    logo: "/images/dmgroup.png",
  },
  {
    name: "Greene Education Services",
    logo: "/images/greene.png",
  },
  {
    name: "Imagine Learning",
    logo: "/images/imaginelearning.png",
  },
  {
    name: "Newline Interactives",
    logo: "/images/newline.png",
  },
  {
    name: "Steel City Services",
    logo: "/images/steelcity.png",
  },
  {
    name: "TALA Professional Services",
    logo: "/images/tala.jpg",
    scale: 1.4,
  },
];
